import React from 'react';
import HomepageContent from '../content/HomepageContent';
import ImageHeader from '../head/ImageHeader';
import {useHeaders} from '../../../api/hooks';
import Loader from '../Loader';
import Error from '../Error';

const Homepage = () => {
    const {data: header, isLoading, error} = useHeaders();

    if (isLoading) {
        return <Loader />;
    }

    if (error) {
        return <Error errors={[error]} />;
    }

    return (
        <>
            <ImageHeader type="filter" header={header[0]} />
            <HomepageContent />
        </>
    );
};

export default Homepage;
